import {
    TRADE_IN_TRANSACTION_GET_LIST,
    TRADE_IN_TRANSACTION_GET_DETAILS,
    TRADE_IN_TRANSACTION_FILTER,
    TRADE_IN_TRANSACTION_CLEAR_FILTER,
    TRADE_IN_TRANSACTION_SORT,
    TRADE_IN_TRANSACTION_GET_QUESTIONNAIRE,
    TRADE_IN_TRANSACTION_GET_ELIGIBLE_ARTICLES,
    TRADE_IN_DETAIL_GET_LIST,
    TRADE_IN_DETAIL_LIST_FILTER,
    TRADE_IN_DETAIL_LIST_CLEAR_FILTER,
    TRADE_IN_DETAIL_LIST_SORT
} from "../actions/types";

const INITIAL_STATE = {
    tradeInTransactions: [],
    tradeInTransaction: {},
    tradeInTransactionQuestionnaire: [],
    tradeInTransactionEligibleArticles: [],
    sorting: {
        orderBy: 'createdAt',
        sort: 'desc'
    },
    filters: {
        imei: '',
        createdAt: {
            from: null,
            to: null
        }
    },
    tradeInDetailList: [],
    tradeInDetailSorting: {
        orderBy: 'createdAt',
        sort: 'desc'
    },
    tradeInDetailListFilters: {
        createdAt: {
            from: null,
            to: null
        }
    }
}

const tradeInReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case TRADE_IN_TRANSACTION_GET_LIST:
            return {
                ...state,
                tradeInTransactions: action.payload.data
            }
        case TRADE_IN_TRANSACTION_GET_DETAILS:
            return {
                ...state,
                tradeInTransaction: action.payload.data,
            }
        case TRADE_IN_TRANSACTION_GET_QUESTIONNAIRE:
            return {
                ...state,
                tradeInTransactionQuestionnaire: action.payload.data,
            }
        case TRADE_IN_TRANSACTION_GET_ELIGIBLE_ARTICLES:
            return {
                ...state,
                tradeInTransactionEligibleArticles: action.payload.data,
            }
        case TRADE_IN_TRANSACTION_FILTER:
            return {
                ...state,
                filters: {
                    ...state.filters,
                    [action.payload.filterKey]: action.payload.filterValue
                }
            }
        case TRADE_IN_TRANSACTION_CLEAR_FILTER:
            return {
                ...state,
                filters: {
                    imei: '',
                    createdAt: {
                        from: null,
                        to: null
                    }
                }
            }
        case TRADE_IN_TRANSACTION_SORT:
            return {
                ...state,
                sorting: action.payload
            }
        case TRADE_IN_DETAIL_GET_LIST: 
            return {
                ...state,
                tradeInDetailList: action.payload.data
            }
        case TRADE_IN_DETAIL_LIST_FILTER:
            return {
                ...state,
                tradeInDetailListFilters: {
                    ...state.tradeInDetailListFilters,
                    [action.payload.filterKey]: action.payload.filterValue
                }
            }
        case TRADE_IN_DETAIL_LIST_CLEAR_FILTER:
            return {
                ...state,
                tradeInDetailListFilters: {
                    createdAt: {
                        from: null,
                        to: null
                    }
                }
            }
        case TRADE_IN_DETAIL_LIST_SORT:
            return {
                ...state,
                tradeInDetailSorting: action.payload
            }
        default:
            return state;
    }
}

export default tradeInReducer;